import BaseAPI from '../api'
const path = 'departments'
export interface DepartmentInterface {
    idDepartment?: number
    departmentName?: string
    departmentStatus?: string
    page?: number;
    limit?: number;
    keyword?: string;
}

export default class DepartmentApi extends BaseAPI {

    static getDepartments(props: DepartmentInterface): Promise<any> {
        return this.api.get(`${path}`, { params: { ...props } })
            .then((res) => res)
    }
    static postDepartment(props: DepartmentInterface): Promise<any> {
        return this.api.post(`${path}`, { ...props }, {})
            .then((res) => res)
    }
    static patchDepartment(idDepartment: string, props: DepartmentInterface): Promise<any> {
        return this.api.patch(`${path}/${idDepartment}`, { ...props }, {})
            .then((res) => res)
    }
    static getDepartment(idDepartment: string): Promise<any> {
        return this.api.get(`${path}/${idDepartment}`, {})
            .then((res) => res)
    }
}